import { h, Component } from 'preact';
import Store from 'store/store';
// import { joinClasses } from 'utils/utils';
import * as jsonPointer from 'utils/jsonPointer';
import { showModal } from 'utils/modal';
import formatDateTime from 'utils/formatDateTime';
import dateDistance from 'utils/dateDistance.mjs';
import { isFocusStudio } from 'utils/studioConfig';

import Button from 'components/button/button';
import Rewind from 'components/icons/rewind';
import VersionHistory from 'components/versionHistory/versionHistory';

import s from 'components/button/versionHistoryButton.sss';

export default class VersionHistoryButton extends Component {
	constructor(props) {
		super(props);
		this.openModal = this.openModal.bind(this);
	}

	async openModal() {
		await showModal(VersionHistory, { path: this.props.path });
	}

	getIntroMessage(type, commits) {
		if (type === 'publish') {
			const isMoviePage = this.props.path?.startsWith('/movies/');
			if (isMoviePage && !isFocusStudio()) {
				const publishType = commits?.publish?.published_status?.endsWith('MOVIE_PLATFORM') ? 'Movie platform' : 'Holding page';
				return `${publishType} last published`;
			}

			return 'Last published';
		}
		return 'Last saved';
	}

	renderLastUpdate() {
		const commits = jsonPointer.get(Store.get().data, this.props.path)?.commits;
		// const type = ['publish', 'current'].find(type => commits?.[type]);
		const type = (commits?.publish?.at && commits.publish.at >= commits.current?.at) ? 'publish' : 'current';
		if (!type || !commits?.[type]) return;
		const intro = this.getIntroMessage(type, commits);
		const date = new Date(commits[type].at);
		const startOfDay = new Date();
		startOfDay.setHours(0, 0, 0, 0);
		const relative = date >= startOfDay ? formatDateTime(date, 'hh:mmtt') : dateDistance(date);
		return (
			<div class={s.update}>
				<div class={s.at} title={formatDateTime(date, 'yyyy-MM-dd HH:mm:ss')}>{intro} {relative}</div>
			</div>
		);
	}

	render() {
		return (
			<div class={s.wrapper}>
				{this.renderLastUpdate()}
				<Button dark={this.props.dark} icon={Rewind} class={s.button} onClick={this.openModal} title="Version history" />
			</div>
		);
	}
}